module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/main/main.container.html
// module id = ./src/app/containers/main/main.container.html
// module chunks = 1